import { render, staticRenderFns } from "./selfOrder.vue?vue&type=template&id=d6f098ea&scoped=true&"
import script from "./selfOrder.vue?vue&type=script&lang=js&"
export * from "./selfOrder.vue?vue&type=script&lang=js&"
import style0 from "./selfOrder.vue?vue&type=style&index=0&id=d6f098ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f098ea",
  null
  
)

export default component.exports